/** Spec 004 — small inscriptional labels for a member's role and account status. Quiet by default;
 *  only the disabled state carries a warning tint so a deactivated account is legible at a glance. */

export function RoleBadge({ role }: { role: 'member' | 'board' | 'admin' }) {
  return (
    <span className="inline-block rounded-sm border border-border px-2 py-0.5 font-display text-[0.65rem] font-semibold uppercase tracking-[0.14em] text-muted">
      {role}
    </span>
  );
}

export function StatusBadge({ status }: { status: 'active' | 'disabled' }) {
  const disabled = status === 'disabled';
  return (
    <span
      className={`inline-block rounded-sm px-2 py-0.5 font-display text-[0.65rem] font-semibold uppercase tracking-[0.14em] ${
        disabled ? 'border border-error/40 bg-error/5 text-error' : 'border border-success/40 bg-success/5 text-success'
      }`}
    >
      {status}
    </span>
  );
}
